/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Not_Completed_StatusInputs */

const en_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not completed`)
};

const fr_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non termine`)
};

const de_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht abgeschlossen`)
};

const it_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non completato`)
};

const ru_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не завершено`)
};

const es_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No completado`)
};

const zh_cn2_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未完成`)
};

const ja_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未完了`)
};

const hi_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा नहीं हुआ`)
};

const pt_pt2_snapshot_history_not_completed_status = /** @type {(inputs: Snapshot_History_Not_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não concluído`)
};

/**
* | output |
* | --- |
* | "Not completed" |
*
* @param {Snapshot_History_Not_Completed_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_not_completed_status = /** @type {((inputs?: Snapshot_History_Not_Completed_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Not_Completed_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_not_completed_status(inputs)
	if (locale === "de") return de_snapshot_history_not_completed_status(inputs)
	if (locale === "it") return it_snapshot_history_not_completed_status(inputs)
	if (locale === "ru") return ru_snapshot_history_not_completed_status(inputs)
	if (locale === "es") return es_snapshot_history_not_completed_status(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_not_completed_status(inputs)
	if (locale === "ja") return ja_snapshot_history_not_completed_status(inputs)
	if (locale === "hi") return hi_snapshot_history_not_completed_status(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_not_completed_status(inputs)
	return en_snapshot_history_not_completed_status(inputs)
});